var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/people",
        backLink: `/people${
          _vm.can("View teacher list") ? "/teachers" : "/students"
        }`,
        pageTitle: _vm.profile.name,
        tabs: true,
        showFooter: _vm.showFooter,
        submitProfileLoading: _vm.submitProfileLoading,
        selectedPeople: _vm.selectedPeople,
        hasFab:
          !!_vm.selectedPeople.length ||
          _vm.selectedTab.includes("availability"),
      },
      on: {
        fabAction: function ($event) {
          _vm.selectedPeople.length
            ? _vm.emailUsers()
            : (_vm.$refs.tabs[0].clickData = { newBtn: true })
        },
        save: function ($event) {
          return _vm.save()
        },
        cancel: function ($event) {
          return _vm.cancel()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-tabs",
                {
                  staticClass: "pr-5 custom-tabs",
                  attrs: { "background-color": "transparent", height: "42px" },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                _vm._l(_vm.filterTabs, function (tab) {
                  return _c(
                    "v-tab",
                    {
                      key: tab.title,
                      class: ["no-link"],
                      attrs: { href: _vm.getUrl(tab), disabled: tab.disabled },
                    },
                    [
                      _c(
                        "Link",
                        {
                          staticClass: "no-link flex align-center min-h-full",
                          attrs: {
                            href: _vm.getUrl(tab),
                            data:
                              tab.slug == "availability"
                                ? {
                                    dayView: Number(_vm.$vuetify.breakpoint.xs),
                                  }
                                : {},
                            "preserve-state": "",
                          },
                        },
                        [_vm._v(_vm._s(tab.title))]
                      ),
                      _vm._v(" "),
                      tab.warning
                        ? _c("v-badge", {
                            attrs: {
                              color: "error--text",
                              icon: "error_outline",
                              "offset-x": "8px",
                              "offset-y": "-2px",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.profile.deleted_at
        ? _c("v-banner", { attrs: { color: "soli-status-red" } }, [
            _c(
              "div",
              {
                staticClass:
                  "white--text flex justify-center gap-4 items-center py-0.5",
              },
              [
                _vm._v(
                  "\n            This user has been deleted.\n            "
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      rounded: "",
                      elevation: "0",
                      href: `/restore-user/${_vm.profile.id}`,
                      color: "white",
                    },
                  },
                  [_vm._v("Restore")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          key: _vm.profile.id,
          attrs: { value: _vm.selectedTab, touchless: "" },
        },
        _vm._l(_vm.filterTabs, function (tab) {
          return _c(
            "div",
            { key: tab.slug },
            [
              _vm.selectedTab.includes(tab.slug)
                ? _c(
                    "v-tab-item",
                    {
                      class: {
                        container: !_vm.$page.props.staffView,
                        setOverflow: tab.slug == "availability",
                      },
                      attrs: { value: _vm.getUrl(tab), transition: false },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pa-1 animate__animated animate__fadeIn",
                        },
                        [
                          _c(
                            tab.comp,
                            _vm._b(
                              {
                                key: _vm.userKey,
                                ref: "tabs",
                                refInFor: true,
                                tag: "component",
                                attrs: { user: _vm.profile, rules: _vm.rules },
                                on: {
                                  success: function ($event) {
                                    _vm.showMessage = true
                                  },
                                  "hook:destroyed": function ($event) {
                                    _vm.showMessage = false
                                  },
                                  editing: function ($event) {
                                    _vm.showFooter = $event
                                  },
                                  reset: function ($event) {
                                    _vm.submitProfileLoading = false
                                  },
                                  submit: function ($event) {
                                    _vm.submitProfileLoading = true
                                  },
                                  "hook:mounted": function ($event) {
                                    _vm.submitProfileLoading = false
                                  },
                                  selectedPeople: function ($event) {
                                    _vm.selectedPeople = $event
                                  },
                                },
                              },
                              "component",
                              _vm.$props,
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.viewInLocation
        ? _c("SoliChoice", {
            attrs: {
              title: "hold up.",
              subtitle: `${_vm.profile.first_name} doesn't belong to this location.`,
              button1:
                _vm.profile.locations.length == 1
                  ? `Switch to ${_vm.profile.locations[0].name}`
                  : "Change Locations",
              button2: "Go Back",
              loading1: "",
              permanent: "",
            },
            on: {
              option1: function ($event) {
                _vm.profile.locations.length == 1
                  ? _vm.$refs.layout.updateSelectedLocation(
                      _vm.profile.locations[0]
                    )
                  : [
                      (_vm.$refs.layout.locationSelect = true),
                      (_vm.$refs.layout.studentLocations =
                        _vm.profile.locations),
                    ]
              },
              option2: function ($event) {
                return _vm.$inertia.visit("/people/students")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.noAssessments
        ? _c("SoliSnack", { attrs: { text: _vm.errors.noAssessments } })
        : _vm._e(),
      _vm._v(" "),
      _vm.composeEmail
        ? _c("ComposeEmail", {
            attrs: {
              emails: _vm.selectedEmails,
              signature: "",
              sendAsStudio: "",
              tinyMCE: "",
              user: _vm.$page.props.auth.user,
              errors: _vm.errors,
            },
            on: {
              success: function ($event) {
                return _vm.emailSuccess()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.composeEmail = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }